<template lang="pug">
v-card.mb-3
  apexcharts(height="350" type="line" :options="chart.chartOptions" :series="chart.series")

</template>

<style lang="stylus">
.table-slim.table-slim.table-slim.table-slim
  padding-left 0
  padding-right 4px

</style>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  props: ['extra'],
  components: {
    apexcharts: VueApexCharts
  },
  computed: {
    chart() {
      const content = JSON.parse(this.extra && this.extra.content || null) || []
      return { chartOptions: {
          title: {
            text: "Tickets",
            align: "center"
          },
          chart: {
            stacked: false,
            toolbar: {
              show: true,
              tools: {
                download: false,
              },
            },
            zoom: {
              enabled: true
            }
          },
          xaxis: {
            type: 'datetime',
            categories: content.xaxis
          },
        },
        series: content.series
      }
    }
  },
}
</script>
 